// extracted by mini-css-extract-plugin
export var numpadContainer = "_qu-1";
export var phoneButton = "_qu-0";